import React, { useState, useEffect } from 'react';
import { Table, Button, message, Modal } from 'antd';
import { EyeOutlined, CheckOutlined, EditOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import ManageHelpDetails from './ManageHelpDetails';

interface HelpDetailsData{
    helpDetailsId:string;
    helpCategoryId:string;
    helpCategoryName:string;
    shortDescription: string;
    description: string;
    documentDescription: string;
    documentName: string;
    mediaDescription: string;
    mediaName: string;
    createdDate:Date;
    createdName:string;
}

const DisplayHelpDetails: React.FC = () => {
  const [helpDetailsData, setHelpDetailsData] = useState<HelpDetailsData[]>([]);
  const [isAddHelpDetailsVisible, setIsAddHelpDetailsVisible] = useState(false);
  const [isEditHelpDetailsVisible, setIsEditHelpDetailsVisible] = useState('');
  const { instance, accounts } = useMsal();
  const [selectedHelpDetailsId, setSelectedHelpDetailsId] = useState<string | null>(null); // Add this state
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [viewDetails, setViewDetails] = useState<HelpDetailsData | null>(null);

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

      useEffect(() => {
        getHelpDetailsData();
      }, [isAddHelpDetailsVisible]);

      const userId = localStorage.getItem("UserId");

      const getHelpDetailsData = async () => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/HelpDetails/GetAllHelpCategoryData/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setHelpDetailsData(response.data);
        } catch (error) {
          console.error("Error fetching help category details", error);
        }
      };

      const handleDeleteHelpDetailsData = async (helpDetailsId: string) => {
        const confirmed = window.confirm('Are you sure you want to delete this item?');
        if(confirmed){
          try {
            const token = await fetchToken();
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/HelpDetails/DeleteHelpDetailsData`, 
              null,
            {
              params:{
                help_details_id: helpDetailsId,
                user_id: userId
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            if (response.status === 200) {
              message.success('Help Details data deleted successfully.');
              getHelpDetailsData();
            }
            else {
              message.error('Failed to delete Help Details data.');
            }            
          } catch (error) {
            console.error("Error deleting details", error);
          }
        }
      };

      const handleViewHelpDetailsData = async (helpDetailsId: string) => {
        const details = helpDetailsData.find(item => item.helpDetailsId === helpDetailsId);
        setViewDetails(details || null);
        setIsViewModalVisible(true);
      };

      const handleEditHelpDetailsData = async(helpDetailsId: string) => {
        setSelectedHelpDetailsId(helpDetailsId);
        setIsAddHelpDetailsVisible(true);
      };

      const columns = [
          {
            title: 'Category Name',
            dataIndex: 'helpCategoryName',
            key: 'helpCategoryName',
            // Custom render to allow wrapping
            render: (text: string) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{text}</div>
            ),
          },
          {
            title: 'Description',
            dataIndex: 'shortDescription',
            key: 'shortDescription',
            // Custom render to allow wrapping
            render: (text: string) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{text}</div>
            ),
          },
          {
            title: 'Actions', // This is the column header
            key: 'actions',
            render: (_: any, record: HelpDetailsData) => (
            <div style={{ display: 'flex', gap: '8px' }}>
                <Button
                    icon={<EyeOutlined />}
                    style={{ color: 'white', backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                    onClick={() => handleViewHelpDetailsData(record.helpDetailsId)}
                >
                    View
                </Button>
                <Button
                    icon={<EditOutlined />}
                    style={{ color: 'white', backgroundColor: '#1890ff', borderColor: '#1890ff' }}
                    onClick={() => handleEditHelpDetailsData(record.helpDetailsId)}
                >
                    Edit
                </Button>
                <Button
                    icon={<DeleteOutlined />}
                    style={{ color: 'white', backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
                    onClick={() => handleDeleteHelpDetailsData(record.helpDetailsId)}
                >
                    Delete
                </Button>
            </div>
            ),
        }
        ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
              <Button type="primary" onClick={() => setIsAddHelpDetailsVisible(false)} style={{ marginRight: 8 }}>
                View Help Details
              </Button>
              <Button type="primary" onClick={() => {
                setIsAddHelpDetailsVisible(true);
                setIsEditHelpDetailsVisible('');
                setSelectedHelpDetailsId(null);
              }} style={{ marginRight: 8 }}>
                Add Help Details
              </Button>
      </div>
            {isAddHelpDetailsVisible ? (<ManageHelpDetails helpDetailsId = {selectedHelpDetailsId} />) : (<Table dataSource={helpDetailsData} columns={columns} rowKey="helpDetailsId" />)}
        
        <div>
            <Modal
                title={
                    <div>
                        Help Details
                        <hr style={{ margin: '5px 0' }} />
                    </div>
                }
                visible={isViewModalVisible}
                onCancel={() => setIsViewModalVisible(false)}
                footer={null}
                width={1300}
                >
                {viewDetails && (
                    <div style={{ padding: '10px' }}>
                        <table style={{
                                width: '100%',
                                border: '1px solid #ccc',
                                borderCollapse: 'collapse',
                                background: '#fafcff'
                            }}>
                            <tbody>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Category Name</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>{viewDetails.helpCategoryName}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Short Description</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>{viewDetails.shortDescription}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Description</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                      {viewDetails?.description && (
                                          <span dangerouslySetInnerHTML={{ __html: viewDetails.description }} />
                                      )}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Document Name</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                        {viewDetails.documentDescription ? (
                                            <>
                                                {viewDetails.documentDescription}
                                                {viewDetails.documentName && (
                                                    <a
                                                        href={`help/${viewDetails.documentName}`}
                                                        download
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ marginLeft: 12, color: '#1890ff', fontSize: 20 }}
                                                        title="Download"
                                                    >
                                                        <DownloadOutlined />
                                                    </a>
                                                )}
                                            </>
                                        ) : (
                                            'No data available'
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Media Name</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                        {viewDetails.mediaDescription ? viewDetails.mediaDescription : 'No data available'}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Media</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                        {viewDetails.mediaName ? (
                                            <video width="320" controls>
                                                <source src={`help/${viewDetails.mediaName}`} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                            ) : (
                                            'No video available'
                                         )}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Created By</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>{viewDetails.createdName}</td>
                                </tr>
                                <tr>
                                    <td style={{ border: '1px solid #ccc', padding: '8px',fontWeight: 'bold', textTransform:'uppercase' }}><strong>Created Date</strong></td>
                                    <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                        {viewDetails.createdDate
                                            ? new Date(viewDetails.createdDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            }).replace(/ /g, '-')
                                            : ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )}
            </Modal>
        </div>
    </div>
  );
};

export default DisplayHelpDetails;